import { SellerListing } from './sellerListingsCollectionReducer';
import { DRAFT } from './toolbarHelpers';

export function hasInsightRecommendation(listing: SellerListing): boolean {
  if (listing.state === DRAFT) {
    return true;
  }
  return Boolean(listing.insights?.nextBestAction || listing.lowVisibility);
}
